import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, AfterViewInit, Directive, TemplateRef, ViewContainerRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { basketVM } from '../../viewmodels/basketVM';
import { ccPaymentVM } from '../../viewmodels/ccPaymentVM';
import { ShoppingBasketService } from '../../../shared/services/shopping-basket.service';
import { CCPaymentService } from '../../../shared/services/cc-payment-service';
import { AuthResultVM, GetSBImagesQuery, SBListDTO } from '../../../shared/viewmodels/ISearchService';
import { DxPopupModule } from 'devextreme-angular';
import Swal from 'sweetalert2';
import { AuthenticationService } from '../../../shared/services/authentication.service';
//import { isNumeric } from 'rxjs/util/isNumeric';
//import { forEach } from '@angular/router/src/utils/collection';
import { Subscription } from 'rxjs';
//import { Location } from '@angular/common';

@Component({
  selector: 'app-doc-basket-ex',
  providers: [ShoppingBasketService, CCPaymentService],
    templateUrl: './doc-basket-ex.component.html',
    styleUrls: ['./doc-basket-ex.component.css']
})

//@Directive({
//  selector: '[isVisible]',
//})

/** doc-basket-ex component*/
export class DocBasketExComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() indexId: string;
  @Input() basketItems: Array<basketVM>;
  @Output() toggle = new EventEmitter<Object>();
  basketItem: basketVM;
  basketCount: number = 0;
  ccPmt: ccPaymentVM;
  docImages: any;
  @Input() planImages: any;
  error: any;
  machineType: number = 0;
  machineLocation: string = '';
  paymentMethod: string = '1';
  buildSbListLock: boolean = false;
  Message: string;
  Username: string = '';
  guid: string = "";
  Description: string = '';
  userInputVisible: boolean = false;
  sbList: SBListDTO[];
  sbQuery: GetSBImagesQuery;
  totAmount: any;
  serviceFee: number = 0;
  isAuthorized: boolean = false;
  authResp: any;
  @Output() loaderEvent = new EventEmitter<boolean>();
  showLoader: boolean = false;
  subscription: Subscription;

  constructor(private service: ShoppingBasketService, private ccPmtSvc: CCPaymentService, private auth: AuthenticationService, private vcRef: ViewContainerRef, private cdr: ChangeDetectorRef) {
    this.basketItems = new Array<basketVM>();
    this.ccPmt = new ccPaymentVM();
    console.log("doc basket ex constructor");
    if (localStorage.getItem("basket") !== null && localStorage.getItem("basket").length > 0) {
      this.basketItems = JSON.parse(localStorage.getItem("basket"));
      //localStorage.clear();
    }
  }

  sendLoader() {
    this.loaderEvent.emit(this.showLoader);
  }

  receiveLoader($event) {
    this.showLoader = $event;
    console.log("show - " + this.showLoader)
  }

  getCount() {
    let cnt = JSON.parse(localStorage.getItem("basket"));
    if (cnt !== null)
      return JSON.parse(localStorage.getItem("basket")).length;
    else
      return 0;
  }

  ngOnInit() {
    //var id = this.route.snapshot.params.machineId;
    console.log("ngOnInit");
    this.machineLocation = localStorage.getItem("machineLocation");
    this.machineType = this.machineLocation == '1' ? 1 : this.machineLocation == '2' ? 2 : 0;
    if (this.machineType === 2)
      this.paymentMethod = '3';
    this.subscription = this.service.BasketCountSub$.subscribe(BasketCount => this.basketCount = BasketCount);
    console.log("Payment method = " + this.paymentMethod);
    //this.service.BasketCountSub.next(this.basketItems.length);
    let cnt = JSON.parse(localStorage.getItem("basket"));
    if (cnt !== null)
      this.service.updateBasketCount(cnt);
    else
      this.service.updateBasketCount(0);
    //this.service.updateBasketCount(cnt);
    this.service.trigger$.subscribe(() => {
      this.reRender();
      //this.basketCount = cnt;
      //this.cdr.markForCheck();
      //console.log("detect changes fired");
    });
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }

  reRender() {
    let cnt = 0;
    if (localStorage.getItem("basket") != null) {
      cnt = JSON.parse(localStorage.getItem("basket")).length;
    }
    this.basketCount = cnt;
    this.cdr.markForCheck();
    console.log("detect changes fired - " + cnt);
  }

  ngAfterViewInit() {
    console.log("ngAfterViewInit");
    let cnt = JSON.parse(localStorage.getItem("basket"));
    if (cnt !== null)
      this.service.updateBasketCount(JSON.parse(localStorage.getItem("basket")).length);
    else
      this.service.updateBasketCount(0);
    //this.service.updateBasketCount(cnt);
    const observedElement = this.vcRef.element.nativeElement.parentElement;

    const observer = new IntersectionObserver(([entry]) => {
      this.renderContents(entry.isIntersecting)
    })
    observer.observe(observedElement)
  }

  renderContents(isIntersecting: boolean) {
    let cnt = JSON.parse(localStorage.getItem("basket"));
    if (cnt !== null)
      this.service.updateBasketCount(JSON.parse(localStorage.getItem("basket")).length);
    else
      this.service.updateBasketCount(0);
    //this.vcRef.clear()

    //if (isIntersecting) {
    //  this.vcRef.createEmbeddedView(this.tplRef)
    //}
  }

  getBasket() {
    console.log('getbasket');
    this.basketItems = JSON.parse(localStorage.getItem("basket"));
    this.machineLocation = localStorage.getItem("machineLocation");
    this.machineType = this.machineLocation == '1' ? 1 : this.machineLocation == '2' ? 2 : 0;
    if (this.machineType === 2)
      this.paymentMethod = '3';
    if (this.basketItems !== null)
      this.service.updateBasketCount(JSON.parse(localStorage.getItem("basket")).length);
    else
      this.service.updateBasketCount(0);

    this.basketItems.forEach(
      bi => { bi.isDownload = true; }
    )

  }

  closeBasket() {
    this.buildSbListLock = false;
    this.basketItems = JSON.parse(localStorage.getItem("basket"));
    if (this.basketItems !== null)
      this.service.updateBasketCount(JSON.parse(localStorage.getItem("basket")).length);
    else
      this.service.updateBasketCount(0);
  }

  async getCredentials() {
    //this.userInputVisible = true;   
    let loc = localStorage.getItem("machineLocation")
    this.Username = '';
    this.Description = '';

    if (loc == '0') {
      let x = await Swal.fire("This is where you will do account lookup");
      //your credentials should populate here
    } else if (loc == '1' || loc == '2') {
      let x = await Swal.fire({
        title: 'Submission information',
        allowEnterKey: true,
        html:
          '<label>User ID</label><br/><input id="Swal-input1" type="text"><br/>' +
          '<label>Description (optional)</label><br/><input id="Swal-input2" type="text">',
        focusConfirm: true,
        preConfirm: () => {
          (<HTMLInputElement>document.getElementById('Swal-input1')).focus;
          return [
            this.Username = (<HTMLInputElement>document.getElementById('Swal-input1')).value,
            this.Description = (<HTMLInputElement>document.getElementById('Swal-input2')).value
          ]
        }
      });

    } else {
      //this.getSB();
    }
  }

  async buildSBList(e) {

    if (this.buildSbListLock) {
      return;
    }
    console.log('buildSBList');
    //this.buildSbListLock = true;

    if (this.paymentMethod === '3') {
      //pay at counter from vault or admin
      await this.getCredentials();
      if (this.Username.length == 0) {
        Swal.fire("You must enter a name for identification");
        return;
      }
    }

    if (this.paymentMethod === '1') {
      //account

      this.Username = localStorage.getItem('uid');
      this.guid = localStorage.getItem('guid');

      await this.auth.ValidateGuid();
      console.log(this.auth.guid + ' ' + this.auth.success);
      if (this.auth.success === 0) {
        //not valid, so get login
        await this.auth.getCredentials();
        console.log('auth ' + this.auth.success)
        if (this.auth.success === 0) {
          //login unsuccessful - abort
          this.buildSbListLock = false;
          return;
        }
        else {
          this.Username = localStorage.getItem('uid');
          this.guid = localStorage.getItem('guid');
          this.buildSbListLock = true;
        }
      }
    }


    //if (this.machineType == 1) {
    //  await this.getCredentials();

    //  if (this.Username.length == 0) {
    //    Swal.fire("You must enter a name for identification");
    //    return;
    //  }

    //} else if (this.machineType == 0) {

    //  if (this.paymentMethod === '1') {
    //    //account payment
    //    this.Username = localStorage.getItem('uid');
    //    this.guid = localStorage.getItem('guid');

    //    //check for valid session
    //    //if invalid - popup login
    //    await this.auth.ValidateGuid();
    //    if (this.auth.success === 0) {
    //      //not valid, so get login
    //      await this.auth.getCredentials();
    //      console.log('auth ' + this.auth.success)
    //      if (this.auth.success === 0)
    //        //login unsuccessful - abort
    //        return;

    //    }
    //  }
    //}

    //if valid - get total amount and verify with user
    //if agrees - check to see if they have enough money
    //if authorized - process SBImages

    var docPages = 0;
    var planPages = 0;

    var sblist: SBListDTO[] = new Array<SBListDTO>();
    this.basketItems.forEach(function (bi) {
      if (bi.isDownload) {
        var sb1 = new SBListDTO();
        sb1.imageType = bi.downloadAs;
        sb1.department = bi.dept;
        sb1.bookDoc = bi.beginBook !== undefined ? bi.beginBook : bi.docId
        sb1.bookPage = bi.beginPage;
        sb1.wholeDoc = bi.wholeDoc;
        sb1.pages = bi.pages;
        sb1.docType = bi.docType;
        sb1.docPageCount = bi.pageCount;
        sblist.push(sb1);

        //for cost calc -needs to be moved to service
        //       console.log('doc type ' + bi.docType);
        if (bi.docType === 'PL' || bi.docType === 'PLAN') {
          if (bi.wholeDoc === true)
            planPages += bi.pageCount
          else
            planPages += bi.pages.length;
        }
        else {
          if (bi.wholeDoc === true)
            docPages += bi.pageCount
          else
            docPages += bi.pages.length;
        }
      }
    });

    //set unindexed desc if applicable
    sblist.forEach(
      bi => { bi.desc = bi.department == 'U' ? 'U ' + this.service.getUnindexedType(bi.docType) : '' }
    )

    //  console.log(sblist);
    this.sbList = sblist;
    if (sblist.length > 0) {
      let imgquery = new GetSBImagesQuery({
        emailList: false,
        emailAddress: '',
        zipList: false,
        sBList: sblist,
        credentialGUID: this.guid,
        submissionType: this.machineType,
        internalUserID: this.Username,
        internalDescription: this.Description,
        optionalPhone: '',
        optionalZipCode: ''
      });

      this.sbQuery = imgquery;
      if (this.indexId)
        this.sbQuery.internalDescription = this.service.getUnindexedType(this.indexId);

      //await this.getSBAmount();
      this.totAmount = (planPages * 5) + (docPages * 2);

      ///branching for payment methods & machine types
      if (this.paymentMethod === '1') {
        //account payment method
        Swal.fire({
          title: 'Total Cost',
          text: 'for this download - $' + this.totAmount + '.00',
          showCancelButton: true
          //        confirmButtonText: 'OK'
        }).then((result) => {
          if (result.value === true) {
            console.log('cost accepted ' + result.value);
            this.getSBAuth();
          }
          else
            //cancelled
            //this.buildSbListLock = false;
            return;
        })
      } else if (this.paymentMethod === '2') {
        //cc payment
        this.getCreditCardInfo();
      } else if (this.paymentMethod === '3') {
        //print to the counter
        if (this.machineType === 1) {
          Swal.fire({
            title: 'Total Cost',
            text: 'for this download - $' + this.totAmount + '.00',
            showCancelButton: true
          }).then((result) => {
            if (result.value === true) {
              this.queueSB();
            }
            else
              //cancelled
              //this.buildSbListLock = false;
              return;
          })
        } else {
          //admin
          this.queueSB();
        }
      }

      //  if (this.paymentMethod === '1' || (this.paymentMethod === '3' && this.machineType === 1)) {
      //    //account or counter payment for vault 
      //    Swal.fire({
      //      title: 'Total Cost',
      //      text: 'for this download - $' + this.totAmount + '.00',
      //      showCancelButton: true
      //      //        confirmButtonText: 'OK'
      //    }).then((result) => {
      //      if (result.value === true) {
      //        console.log('cost accepted ' + result.value);
      //        costAccepted = 1;
      //        if (this.machineType == 1 && this.paymentMethod === '3') {
      //          //vault & pay at counter
      //          this.printSB();
      //          this.getSB();
      //        } else if (this.paymentMethod === '1') {
      //          //pay by account
      //          this.getSBAuth();
      //        }
      //      }
      //      else
      //        return;
      //    })
      //  }
      //  else if (this.paymentMethod === '2') {
      //    //credit card
      //    this.getCreditCardInfo();
      //  }
      //  else if (this.paymentMethod === '3' && this.machineType === 2) {
      //    this.printSB();
      //  }

    } else {
      Swal.fire("Error", "Please select at least one item to download");
    }
    //this.buildSbListLock = false;
  }

  async getSBAuth() {
    console.log('getSBAuth');
    await this.service.getSBAuth(this.sbQuery).toPromise()
      .then(data => {
        this.authResp = data.body;
        //console.log('msg - ' + this.authResp.msg);
        //console.log('keys ' + Object.keys(data.body));
      });

    //(error => { this.error = error }),
    //(() => { console.log('authResp  - '+ this.authResp.success); });

    console.log('post getSBAuth ' + this.authResp.success);

    if (this.authResp.success === 0) {
      Swal.fire('Authorization Failed', this.authResp.msg);
      return;
    }
    else {
      //kick off the download or print
      if (this.showLoader === false) {
        this.showLoader = true;
        this.sendLoader();
      }

      //Branch for download vs print
      if (this.machineType === 0)
        this.getSB();
      else if (this.machineType === 1)
        this.printSB();
    }
  }

  async getCreditCardInfo() {

    console.log('cc info');

    let x = await Swal.fire({
      title: 'Enter Credit Card Info',
      showCancelButton: true,
      allowEnterKey: true,
      html:
        '<br>' +
        '<table>' +
        '<tr><td><label for="ccnum"   style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Card Number</label></td><td><input id="ccnum" type="text" maxlength="19" size="30" placeholder="0000 0000 0000 0000" value="' + this.ccPmt.ccNum + '"> </td></tr > ' +
        '<tr><td><label for="ccfname" style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">First Name</label></td><td><input id="ccfname" type="text" size="30" value="' + this.ccPmt.ccFname + '"></td></tr>' +
        '<tr><td><label for="cclname" style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Last Name</label></td><td><input id="cclname" type="text" size="30" value="' + this.ccPmt.ccLname + '"></td></tr>' +
        '<tr><td><label for="ccmonth" style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Exp Month</label></td><td style="text-align: left"><input id="ccmonth" type="text" size="5" maxlength="2" placeholder="00" value="' + this.ccPmt.ccMonth + '"></td></tr>' +
        '<tr><td><label for="ccyear"  style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Exp Year</label></td><td style="text-align: left"><input id="ccyear" type="text" size="5" maxlength="2" placeholder="00" value="' + this.ccPmt.ccYear + '"></td></tr>' +
        '<tr><td><label for="ccv"     style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">CCV</label></td><td style="text-align: left"><input id="ccv" type="text" size="5" maxlength="4" placeholder="0000" value="' + this.ccPmt.ccv + '"></td></tr>' +
        '<tr><td><label for="cczip"   style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Zip Code</label></td><td style="text-align: left"><input id="cczip" type="text" size="5" maxlength="5" placeholder="00000" value="' + this.ccPmt.ccZip + '"></td></tr>' +
        '</table>' +
        '<br> *** The cost for this download is $' + this.totAmount.toString() + '.00 - a convenience fee of 3 percent will be added to this charge, with a minimum convenience fee of $1.00. <p style="color:red; font-weight:500;">Charges will appear on your statement as<br> PayGov, Indianapolis, IN</p>. ',

      focusConfirm: true,
      preConfirm: () => {
        return [
          this.ccPmt.ccNum = (<HTMLInputElement>document.getElementById('ccnum')).value,
          this.ccPmt.ccFname = (<HTMLInputElement>document.getElementById('ccfname')).value,
          this.ccPmt.ccLname = (<HTMLInputElement>document.getElementById('cclname')).value,
          this.ccPmt.ccMonth = (<HTMLInputElement>document.getElementById('ccmonth')).value,
          this.ccPmt.ccYear = (<HTMLInputElement>document.getElementById('ccyear')).value,
          this.ccPmt.ccv = (<HTMLInputElement>document.getElementById('ccv')).value,
          this.ccPmt.ccZip = (<HTMLInputElement>document.getElementById('cczip')).value
        ]
      }
    }).then((result) => {
      if (result.dismiss === undefined) {
        console.log('cc ok');
        this.authorizeCard();
      }
      else {
        console.log('cc cancel');
        this.buildSbListLock = false;
        return;
      }
    });
  }

  async authorizeCard() {

    this.service.logServiceError('begin CC Auth');

    //validate card info
    this.ccPmt.realccNum = this.ccPmt.ccNum.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()\s]/g, "");
    if (this.ccPmt.ccMonth.length === 1)
      this.ccPmt.ccMonth = '0' + this.ccPmt.ccMonth;
    this.ccPmt.ccAmount = this.totAmount;

    let msg = this.ccPmtSvc.ValidateCard(this.ccPmt);
    if (msg === '') {

      this.service.logServiceError('CC Info validated');

      this.ccPmt.authCode = '';
      let response = '';
      this.showLoader = true;
      this.sendLoader();
      //      await this.service.getCCAuth(this.realccNum, this.ccFname, this.ccLname, this.ccMonth, this.ccYear, this.ccv, this.ccZip, this.totAmount).toPromise()
      await this.ccPmtSvc.getCCAuth(this.ccPmt).toPromise()
        .then(data => {
          //console.log('data ' + data);
          response = data;
          this.ccPmt.status = this.ccPmtSvc.getElement(data, '<PaymentStatus>');
          if (this.ccPmt.status === 'Declined') {
            let responseText = this.ccPmtSvc.getElement(data, '<ResponseText>');
            this.service.logServiceError('CC Payment Declined - ' + response);
            this.showLoader = false;
            this.sendLoader();
            this.buildSbListLock = false;
            Swal.fire('Payment Declined')
          }
          else if (this.ccPmt.status === 'Authorized' || this.ccPmt.status === 'Pending') {
            //approved
            this.ccPmt.authCode = this.ccPmtSvc.getElement(data, '<AuthorizationTransactionCode>');
            this.sbQuery.authCode = this.ccPmt.authCode;
            this.serviceFee = +this.ccPmtSvc.getElement(data, '<ServiceFeeAmount>');
            this.ccPmt.orderId = this.ccPmtSvc.getElement(data, '<OrderId>');
            console.log('Payment Authorized - ' + this.ccPmt.authCode + ' - ' + this.ccPmt.orderId);
            this.service.logServiceError('Payment Authorized - ' + this.ccPmt.authCode + ' - ' + this.ccPmt.orderId + ' ' + this.machineType);

            //all is well - branch for download vs print
            if (this.machineType === 0)
              this.getSB();
            else if (this.machineType === 1)
              this.printSB();
            else
              this.service.logServiceError("Error - " + this.machineType);
            this.buildSbListLock = true;
            Swal.fire("Request submitted.");
          }
          else {
            //log the different status
            this.service.logServiceError('Unknown Payment Status - ' + response);
            this.showLoader = false;
            this.sendLoader();
          }
        });
    }
    else {
      //validation failed - go back to the cc form
      this.buildSbListLock = false;
      this.service.logServiceError('CC not validated - ' + msg);
      await Swal.fire('Validation Error', msg);
    }
    //    this.showLoader = false;
    //    this.sendLoader();
  }

  async printSB() {

    //handle print requests for account & cc payments
    this.service.logServiceError('print SB in doc basket ' + this.ccPmt.authCode + ' ' + this.auth.uid);
    this.sbQuery.totalFee = this.totAmount;
    //this.sbQuery.serviceFee = this.serviceFee;

    if (this.paymentMethod === '1') {
      this.sbQuery.internalUserID = 'Account - ' + this.auth.uid;
    } else if (this.paymentMethod === '2') {
      //this.sbQuery.internalUserID = this.ccPmt.ccFname + ' ' + this.ccPmt.ccLname + '- Auth ' + this.ccPmt.authCode;
      this.sbQuery.internalUserID = 'Auth ' + this.ccPmt.authCode;
    }

    if (this.sbList.length > 0) {
      //      console.log("Calling download" + this.sbQuery);
      await this.service.printSBImages(this.sbQuery).toPromise()
        .then(data => {
          console.log(data.body);
          if (data.body === true) {

            //remove checked items from basket
            this.clearBasket();

            this.downloadComplete(false);
          }
          else {
            this.showLoader = false;
            this.sendLoader();
            if (this.paymentMethod === '2')
              //cc
              this.voidTransaction();
          }
        });
    }

    //auto logout for account pmts
    if (this.paymentMethod === '1')
      this.auth.autoLogout();
  }

  async queueSB() {

    //queue the images for the counter to process
    console.log('queueSB');
    this.showLoader = true;
    this.sendLoader();

    this.sbQuery.submissionType = 1; //sends the images to a print queue in GetSBImages

    await this.service.getSBImages(this.sbQuery).subscribe(
      data => {
        //nothing to do, since this execution path returns a null value
        console.log('print request queued');
      });
    this.clearBasket();

    this.showLoader = false;
    this.sendLoader();
    Swal.fire('Request Completed', 'Check with the front counter');
  }

  async getSB() {

    //   this.showLoader = true;
    //   this.sendLoader();
    var success: number = 1;

    if (this.paymentMethod === '2')
      this.service.logServiceError("Entering getSB " + this.ccPmt.authCode);

    console.log('getSB');
    if (this.sbList.length > 0) {
      //      console.log("Calling download" + this.sbQuery);
      await this.service.getSBImages(this.sbQuery).subscribe(
        data => {
          //console.log(data);
          this.docImages = data;
          //console.log('download ' + this.docImages);

          this.clearBasket();
          //this.basketItems = this.basketItems.filter(item => item.isDownload == false);
          //if (localStorage.getItem("basket") !== null && localStorage.getItem("basket").length > 0) {
          //  let basketls = JSON.parse(localStorage.getItem("basket"));
          //  localStorage.setItem("basket", JSON.stringify(basketls.filter(item => item.isDownload == true)));
          //}

          ////const url = window.URL.createObjectURL(this.docImages);
          ////window.open(url);
          //////window.URL.revokeObjectURL(url);

          try {

            //IE11 support
            if (data.size != 0) {
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(this.docImages, "MyCarrollCounty.zip");
              }
              // other browsers
              else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                const url = window.URL.createObjectURL(this.docImages);
                a.href = url;
                a.download = "MyCarrollCounty.zip";
                a.click();
                window.URL.revokeObjectURL(url);
              }
              this.downloadComplete(true);
            }
            else {
              this.service.logServiceError('Download Error - filesize = 0' + ' - ' + window.navigator.appName + ' ' + window.navigator.appVersion + ' ' + window.navigator.platform);
              success = 0;
            }
          }
          catch (error) {
            //logging here
            this.service.logServiceError('Download Error - ' + Object.keys(error) + ' ' + error.error + ' ' + this.ccPmt.authCode + ' - ' + window.navigator.appName + ' ' + window.navigator.appVersion + ' ' + window.navigator.platform);
            this.voidTransaction();
          }
          finally {

            //            console.log('getsb finally');
            //            this.showLoader = false;
            //            this.sendLoader();
          }
        },
        error => {
          //logging here
          this.error = error;
          this.service.logServiceError('Service.SBImages Error - ' + Object.keys(error) + ' ' + error.headers + ' ' + error.name + ' ' + error.message + ' ' + Object.keys(error.error) + ' ' + this.ccPmt.authCode + '  - ' + window.navigator.appName + ' ' + window.navigator.appVersion + ' ' + window.navigator.platform);
          this.voidTransaction();
        }
      );

    } else {
      Swal.fire("Please select at least one item to download.");
    }
    //    this.showLoader = false;
    //    this.sendLoader();

    //if (success == 0) {
    //  this.showLoader = false;
    //  this.sendLoader();
    //  this.voidTransaction();
    //}

    return;

  }

  clearBasket() {

    this.basketItems = this.basketItems.filter(item => item.isDownload == false);
    if (localStorage.getItem("basket") !== null && localStorage.getItem("basket").length > 0) {
      let basketls = JSON.parse(localStorage.getItem("basket"));
      localStorage.setItem("basket", JSON.stringify(basketls.filter(item => item.isDownload == true)));
    }
  }


  async getSBAmount() {
    await this.service.getSBAmount(this.sbQuery).subscribe(
      data => {
        this.totAmount = data;
        console.log('amount - ' + data);
        console.log(Object.keys(data));
      },
      error => { this.error = error }
    );
  }


  async downloadComplete(showDownLoadMsg: boolean) {

    /*this.basketItems = this.basketItems.filter(item => item.isDownload == false);*/

    //    this.showLoader = true;
    //    this.sendLoader();
    this.service.logServiceError('Entering downloadComplete ');

    if (!this.sbQuery.internalUserID)
      this.sbQuery.internalUserID = '';


    if (this.ccPmt.authCode != '') {

      //cc transaction
      this.sbQuery.authCode = this.ccPmt.authCode;
      this.sbQuery.orderId = this.ccPmt.orderId;
      this.sbQuery.totalFee = this.ccPmt.ccAmount;
      console.log('auth ' + this.ccPmt.authCode + ' order ' + this.ccPmt.orderId)
      await this.ccPmtSvc.completeSBChargeandCCSale(this.sbQuery).toPromise()
        .then(data => {
          this.service.logServiceError('saveSBChargeandCCSale - ' + data.body + ' ' + this.ccPmt.authCode);
        },
          error => {
            //logging here
            this.error = error;
            this.service.logServiceError('saveSBCharge Error - ' + Object.keys(error) + ' ' + error.headers + ' ' + error.name + ' ' + error.message + ' ' + Object.keys(error.error) + ' ' + this.ccPmt.authCode + '  - ' + window.navigator.appName + ' ' + window.navigator.appVersion + ' ' + window.navigator.platform);
          }
        );

    } else {

      //write data to atransaction for account trans
      await this.service.saveSBCharge(this.sbQuery).toPromise()
        .then(data => {
          this.service.logServiceError('saveSBCharge - ' + data.body)
          console.log('sbCharge ' + data.body);
        },
          error => {
            //logging here
            this.error = error;
            this.service.logServiceError('saveSBCharge Error - ' + Object.keys(error) + ' ' + error.headers + ' ' + error.name + ' ' + error.message + ' ' + Object.keys(error.error) + ' ' + this.ccPmt.authCode + '  - ' + window.navigator.appName + ' ' + window.navigator.appVersion + ' ' + window.navigator.platform);
          }
        );
    }

    this.buildSbListLock = false;

    ////    write data to atransaction for account trans
    //    await this.service.saveSBCharge(this.sbQuery).toPromise()
    //      .then(data => {
    //        this.service.logServiceError('saveSBCharge - ' + data.body)
    //        console.log('sbCharge ' + data.body);
    //      },
    //        error => {
    //  //        logging here
    //          this.error = error;
    //          this.service.logServiceError('saveSBCharge Error - ' + Object.keys(error) + ' ' + error.headers + ' ' + error.name + ' ' + error.message + ' ' + Object.keys(error.error) + ' ' + this.ccPmt.authCode + '  - ' + window.navigator.appName + ' ' + window.navigator.appVersion + ' ' + window.navigator.platform);
    //        }
    //      );


    ////    capture the cc trans if applicable
    //    if (this.ccPmt.authCode != '') {
    //      this.service.logServiceError("downloadCompete " + this.ccPmt.authCode);
    //      console.log('downloadComplete - ' + this.ccPmt.orderId)
    //      let response = '';
    //  //    2nd step of credit card sale
    //      await this.ccPmtSvc.ccCompleteSale(this.ccPmt).toPromise()
    //        .then(data => {
    //          console.log('capture - ' + data);
    //          response = data;
    //          let status = this.ccPmtSvc.getElement(response, '<ResponseText>');
    //          this.service.logServiceError('capture - ' + data);
    //          console.log('status ' + status)
    //        },
    //          error => {
    //    //        logging here
    //            this.error = error;
    //            this.service.logServiceError('CC Capture Error - ' + Object.keys(error) + ' ' + error.headers + ' ' + error.name + ' ' + error.message + ' ' + Object.keys(error.error) + ' ' + this.ccPmt.authCode + '  - ' + window.navigator.appName + ' ' + window.navigator.appVersion + ' ' + window.navigator.platform);
    //            this.voidTransaction();
    //          }
    //        );
    //      console.log('capture complete')
    //    }

    //all done
    this.showLoader = false;
    this.sendLoader();

    this.basketItems = JSON.parse(localStorage.getItem("basket"));

    if (showDownLoadMsg) {
      let msg = '';
      if (this.ccPmt.authCode.length > 0)
        msg = 'Payment Authorization Code - ' + this.ccPmt.authCode
      msg += '<br>Check your downloads folder for a file named MyCarrollCounty.Zip'
      await Swal.fire({
        title: "Download request complete",
        html: msg
      });
    } else
      Swal.fire('Print Job Sent')


    //this.toggle.emit(this.basketItems);

    //    this.ccPmtSvc.resetCCPmt();

    //reset cc variables here
    this.ccPmt.authCode = '';
    this.ccPmt.ccNum = '';
    this.ccPmt.realccNum = '';
    this.ccPmt.ccFname = '';
    this.ccPmt.ccLname = '';
    this.ccPmt.ccMonth = '';
    this.ccPmt.ccYear = '';
    this.ccPmt.ccv = '';
    this.ccPmt.ccZip = '';
    this.ccPmt.orderId = '';
    this.ccPmt.ccAmount = 0;
    this.ccPmt.status = '';
    this.ccPmtSvc.infoEntered = 0;
  }

  async voidTransaction() {

    if (this.paymentMethod === '2') {

      if (this.showLoader === false) {
        this.showLoader = true;
        this.sendLoader();
      }
      this.service.logServiceError("void transaction - " + this.ccPmt.authCode);

      let response = '';
      //void
      await this.ccPmtSvc.voidTransaction(this.ccPmt).toPromise()
        .then(data => {
          //console.log('void - ' + data);
          this.service.logServiceError('void trans - ' + this.ccPmt.authCode + ' ' + data);
        });

      this.showLoader = false;
      this.sendLoader();
    }
    Swal.fire('Download Error', 'Transaction has been voided');
    this.showLoader = false;
    this.sendLoader();
  }


  deleteRow(event) {
    if (localStorage.getItem("basket") !== null && localStorage.getItem("basket").length > 0) {
      let basketls = JSON.parse(localStorage.getItem("basket"));
      this.service.updateBasketCount(basketls.length);
      localStorage.setItem("basket", JSON.stringify(basketls.filter(item => item.bookpage !== event.key.bookpage)));
      //this.service.updateBasketCount(localStorage.getItem("basket").length);
    }
  }

  @HostListener('document:visibilitychange', ['$event'])
  visibilitychange() {
    this.checkHiddenDocument();
  }

  checkHiddenDocument() {
    console.log('OnPageVisible');
    console.log('basket visible');
    let cnt = JSON.parse(localStorage.getItem("basket"));
    if (cnt !== null)
      this.service.updateBasketCount(JSON.parse(localStorage.getItem("basket")).length);
    else
      this.service.updateBasketCount(0);

    this.cdr.detectChanges();
  }

}
